"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var portraitDefaults = {
  background: 'none',
  borderRadius: '4px',
  textColor: 'initial',
  accentColor: 'primary',
  gradientColor: 'rgba(30, 31, 34, 1)',
  name: {
    fontFamily: 'heading',
    styles: {
      fontWeight: 'normal',
      textTransform: 'none'
    }
  },
  textSmall: {
    fontFamily: 'heading',
    styles: {
      fontWeight: 'bold',
      textTransform: 'uppercase'
    }
  }
};
var portraitTheme = {
  horizon: portraitDefaults,
  dcl: _objectSpread(_objectSpread({}, portraitDefaults), {}, {
    textColor: 'black'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, portraitDefaults), {}, {
    background: 'secondary',
    textColor: 'greydark',
    accentColor: 'primary',
    name: {
      fontFamily: 'normal'
    },
    textSmall: {
      fontFamily: 'bold',
      fontWeight: 'bold'
    }
  }),
  lionsLive: _objectSpread(_objectSpread({}, portraitDefaults), {}, {
    name: _objectSpread(_objectSpread({}, portraitDefaults.name), {}, {
      styles: _objectSpread(_objectSpread({}, portraitDefaults.name.styles), {}, {
        textTransform: 'uppercase'
      })
    })
  }),
  money2020: {
    background: 'black',
    gradientColor: 'rgba(0, 0, 0, 1)',
    textColor: 'white',
    accentColor: 'white',
    name: {
      styles: _objectSpread(_objectSpread({}, portraitDefaults.name.styles), {}, {
        padding: 0,
        // removes the global style for the pink slash
        '&::before': {
          content: 'none'
        }
      })
    }
  }
};
var _default = portraitTheme;
exports.default = _default;